module.exports = __webpack_public_path__ + "img/logo_scopos_branco.f714a357.png";